import { Link } from 'react-router-dom';

import logoVerticalWhite from '@/assets/logo-vertical-white.svg';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-800 border-t border-white/10">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src={logoVerticalWhite} 
              alt="BlackRent Autoservis" 
              width="180"
              height="56"
              className="h-14"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Prémiový autoservis a autopožičovňa špecializujúca sa na luxusné a športové vozidlá.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Rýchle odkazy
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Domov
                </Link>
              </li>
              <li>
                <Link to="/cennik" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Cenník
                </Link>
              </li>
              {/* Galéria - skryté kým nemáme vlastné fotky */}
              {/* <li>
                <Link to="/galerija" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Galéria
                </Link>
              </li> */}
              <li>
                <Link to="/o-nas" className="text-sm text-gray-400 hover:text-white transition-colors">
                  O nás
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Služby
            </h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Servis & Opravy
                </a>
              </li>
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Diagnostika
                </a>
              </li>
              <li>
                <Link to="/nahradne-vozidla" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Náhradné vozidlá
                </Link>
              </li>
              <li>
                <a 
                  href="#services" 
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Detailing
                </a>
              </li>
            </ul>
          </div>

          {/* Customer Zone */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Zákaznícka zóna
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/rezervacia" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Rezervovať termín
                </Link>
              </li>
              <li>
                <Link to="/cennik" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Cenník
                </Link>
              </li>
              <li>
                <Link to="/nahradne-vozidla" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Náhradné vozidlá
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Môj účet
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="text-sm text-gray-400">
                  Bratislava, Slovensko
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gold-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:info@blackrent.sk" className="text-sm text-gray-400 hover:text-white transition-colors">
                  info@blackrent.sk
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gold-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:+421900000000" className="text-sm text-gray-400 hover:text-white transition-colors">
                  +421 900 000 000
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} BlackRent Servis. Všetky práva vyhradené.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/ochrana-sukromia" className="text-sm text-gray-400 hover:text-white transition-colors">
                Ochrana súkromia
              </Link>
              <Link to="/obchodne-podmienky" className="text-sm text-gray-400 hover:text-white transition-colors">
                Obchodné podmienky
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
